import CallsPage from 'react-components/calls-page/calls-page';
import { Routes, SyncHook } from '../route-types';
import { useNavigateToCalls } from '../navigation-hooks';

const CALLS_PATH = '/calls';

const routes: Routes = [
  {
    path: CALLS_PATH,
    element: <CallsPage />,
  },
];

const useSyncHook: SyncHook = null;

const useNavigationHooks = () => {
  const navigateToCalls = useNavigateToCalls();
  return {
    toCalls: (filters?: { onlyUnassignedCalls?: boolean }) => {
      navigateToCalls(filters);
    },
  };
};

export const callsPageRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
